export const api = {
  GET_TASKS_LIST: '/tasks/getList',
  GET_TASK_DETAILS: '/tasks/getDetailsByTaskID',
  EDIT_TASK_VISIT: '/tasks/editVisitTask',
  EDIT_TASK_GENERAL: '/tasks/editGeneralTask',
  CLOSE_TASK: '/tasks/closeTask',
};
